module.exports = __webpack_public_path__ + "static/media/traqueurs.42545092.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/chifco_iot/traqueurs.svg
// module id = 661
// module chunks = 0